module.exports = __webpack_public_path__ + "f62897e19034d9f004c6ba5f234d7bde.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/david-khourshid.jpg
// module id = 663
// module chunks = 0